<dynamic-form-v2
    *ngIf="!isLoading"
    entityType="dynamic-mystery-box"
    [formName]="title"
    [(record)]="dynamicMysteryBoxRecord"
    [fields]="fields"
    [viewRoute]="viewRoute"
    [autopopulateEntity]="true"
>
</dynamic-form-v2>

